import { render, staticRenderFns } from "./stat-trend-card.generic.vue?vue&type=template&id=94c33b8a&"
import script from "./stat-trend-card.generic.vue?vue&type=script&lang=js&"
export * from "./stat-trend-card.generic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports